import { Link, generatePath } from "react-router-dom";
import { PROJECTS_MODIFY, PROJECTS_DETAIL } from "@constants/routes/routes";
import { Button } from "reactstrap";
import IProject from "@interfaces/Core/ProjectManager/project";
import { timestampToString } from "@helpers/dates.format";

const listProject = (items: IProject[], handleDelete: Function) => {
  const listAsset = items.map(
    ({ uuid, client, name, key, createdAt, updatedAt }, index) => ({
      uuid,
      order: index + 1,
      client: client?.name ?? null,
      name,
      key,
      createdAt: timestampToString(createdAt),
      updatedAt: timestampToString(updatedAt),
      actions: (
        <>
          <Link to={generatePath(PROJECTS_DETAIL, { uuid })}>
            <Button className="btn-sm btn-primary">
              <span className="lnr lnr-eye" />
            </Button>
          </Link>
          <Link to={generatePath(PROJECTS_MODIFY, { uuid })}>
            <Button className="btn-sm btn-warning">
              <span className="lnr lnr-pencil" />
            </Button>
          </Link>
          <Button
            className="btn-sm btn-danger"
            onClick={() => {
              handleDelete({
                uuid,
                title: name,
              });
            }}
          >
            <span className="lnr lnr-trash" />
          </Button>
        </>
      ),
    })
  );

  return listAsset;
};

export default listProject;
